import { FunctionComponent, SVGProps } from 'react'
export const IconMail: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const clip0 = `${id}-clip0`
  const clip1 = `${id}-clip1`
  const filter0 = `${id}-filter0`
  const filter1 = `${id}-filter1`
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`
  const paint2 = `${id}-paint2`
  const paint3 = `${id}-paint3`
  const paint4 = `${id}-paint4`
  const paint5 = `${id}-paint5`
  const paint6 = `${id}-paint6`
  const paint7 = `${id}-paint7`
  const paint8 = `${id}-paint8`

  return (
    <svg
      width="136"
      height="106"
      viewBox="0 0 136 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0})`} filter={`url(#${filter0})`}>
        <path
          d="M0.500002 29.0234C0.500001 20.463 7.43959 13.5234 16 13.5234H108C116.56 13.5234 123.5 20.463 123.5 29.0234V89.0235C123.5 97.5839 116.56 104.523 108 104.523H16C7.4396 104.523 0.50001 97.5839 0.500009 89.0235L0.500002 29.0234Z"
          fill={`url(#${paint0})`}
          stroke={`url(#${paint1})`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M108 13.5234C116.56 13.5234 123.5 20.463 123.5 29.0234V33.7039C123.5 34.9826 122.803 36.1596 121.681 36.7738L69.4444 65.377C64.8064 67.9167 59.1936 67.9167 54.5556 65.377L2.31901 36.7738C1.19739 36.1596 0.5 34.9826 0.5 33.7039V29.0234C0.5 20.463 7.43959 13.5234 16 13.5234H108Z"
          fill={`url(#${paint2})`}
          stroke={`url(#${paint3})`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath={`url(#${clip1})`}>
          <path
            d="M57.2908 32.8353C58.8019 32.3356 60.3861 32.0774 61.9784 32.0607C62.0028 32.0607 62.0272 32.0607 62.0515 32.0607C62.6527 32.0607 63.2539 32.3022 63.7089 32.7685L66.918 36.0576C67.3405 36.4906 67.568 37.0402 67.6086 37.5981C67.568 35.9577 67.2754 34.3422 66.7554 32.7933C65.8454 30.0954 64.2368 27.6389 62.0026 25.7403C61.7426 25.5155 61.4745 25.299 61.1902 25.0992L56.6 25.0993C55.4626 25.0994 54.4065 25.7239 53.8379 26.7316L48.7118 35.8334L48.4113 36.3747C47.8426 37.3823 47.8427 38.6314 48.4114 39.6389L48.6064 39.9803C49.0532 39.1976 49.5487 38.4731 50.093 37.7986C52.0265 35.4336 54.5368 33.7431 57.2908 32.8353Z"
            fill="#304260"
            stroke={`url(#${paint4})`}
          />
          <path
            d="M57.1644 42.7122C56.6851 41.1467 56.4494 39.5063 56.4575 37.8491L56.4575 37.8408C56.4575 37.7825 56.4575 37.7242 56.4575 37.6659L56.4575 37.6576C56.4818 37.0747 56.7174 36.5084 57.148 36.0671L60.3569 32.7777C60.8037 32.3197 61.3886 32.0865 61.9736 32.0699C60.3731 32.0783 58.797 32.3448 57.286 32.8445C54.5319 33.7522 52.0216 35.4427 50.0963 37.8244C49.552 38.4989 49.0564 39.2234 48.6096 40.0061L53.85 49.3075C54.4187 50.3151 55.4668 50.9396 56.6123 50.9395L62.9491 50.9393C62.6485 50.7145 62.356 50.4897 62.0717 50.2482C59.6993 48.2248 58.0338 45.5934 57.1644 42.7122Z"
            fill="#304260"
            stroke={`url(#${paint5})`}
          />
          <path
            d="M75.3254 35.808C74.9192 36.4991 74.4643 37.1487 73.9768 37.7566C72.084 40.0883 69.6306 41.7621 66.9334 42.6865C65.3736 43.2195 63.7406 43.4944 62.0914 43.5111C62.067 43.5111 62.0427 43.5111 62.0183 43.5111C61.4171 43.5111 60.8159 43.2696 60.361 42.8033L57.1518 39.5142C56.705 39.0562 56.4775 38.465 56.4612 37.8654C56.4531 39.5225 56.6888 41.163 57.1682 42.7285C58.0375 45.6097 59.7112 48.2494 62.0754 50.2562C62.3597 50.4976 62.6522 50.7308 62.9528 50.9473L67.478 50.9471C68.6153 50.9471 69.6715 50.3225 70.2401 49.3149L75.5042 39.9716L75.6748 39.6718C76.2435 38.6642 76.2434 37.4151 75.6747 36.4075L75.3254 35.808Z"
            fill="#304260"
            stroke={`url(#${paint6})`}
          />
          <path
            d="M66.7681 32.8119C67.2881 34.3524 67.5806 35.9762 67.6213 37.6167C67.6294 37.6999 67.6294 37.7832 67.6294 37.8665C67.6132 38.4577 67.3776 39.0489 66.9389 39.507L63.73 42.7963C63.2832 43.2543 62.6983 43.4875 62.1133 43.5042C63.7625 43.4958 65.3955 43.2126 66.9553 42.6796C69.6443 41.7635 72.1059 40.0897 73.9987 37.7497C74.4862 37.1418 74.9411 36.4922 75.3473 35.8011L70.245 26.7412C69.6763 25.7336 68.6283 25.1091 67.4828 25.1092L61.2109 25.1094C61.4872 25.3175 61.7553 25.534 62.0234 25.7505C64.2494 27.6574 65.8581 30.1139 66.7681 32.8119Z"
            fill="#304260"
            stroke={`url(#${paint7})`}
          />
          <path
            d="M67.6172 37.6074C67.6172 37.6907 67.6172 37.7739 67.6257 37.8572C67.6257 37.7739 67.6172 37.699 67.6172 37.6074Z"
            fill="#87A532"
          />
        </g>
      </g>
      <g filter={`url(#${filter1})`}>
        <path
          d="M120 33.0234C128.837 33.0234 136 25.86 136 17.0234C136 8.18688 128.837 1.02344 120 1.02344C111.163 1.02344 104 8.18688 104 17.0234C104 25.86 111.163 33.0234 120 33.0234Z"
          fill="#C8F252"
          fillOpacity="0.15"
        />
        <path
          d="M135.5 17.0234C135.5 25.5839 128.56 32.5234 120 32.5234C111.44 32.5234 104.5 25.5839 104.5 17.0234C104.5 8.46302 111.44 1.52344 120 1.52344C128.56 1.52344 135.5 8.46302 135.5 17.0234Z"
          stroke={`url(#${paint8})`}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.6"
        d="M120.011 23.0234V12.1774L117.708 13.5629V12.1604L120.011 10.7834H121.278V23.0234H120.011Z"
        fill="#C8F252"
      />
      <defs>
        <filter
          id={filter0}
          x="-50"
          y="-36.9766"
          width="224"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2129_12723"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2129_12723"
            result="shape"
          />
        </filter>
        <filter
          id={filter1}
          x="84"
          y="-18.9766"
          width="72"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2129_12723"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2129_12723"
            result="shape"
          />
        </filter>
        <radialGradient
          id={paint0}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62 59.0234) rotate(90) scale(63 84)"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.24" />
          <stop offset="1" stopColor="white" stopOpacity="0.08" />
        </radialGradient>
        <linearGradient
          id={paint1}
          x1="62"
          y1="12.3359"
          x2="62"
          y2="105.711"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0.04" />
        </linearGradient>
        <radialGradient
          id={paint2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62 41.4295) rotate(90) scale(28.594 62)"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.24" />
          <stop offset="1" stopColor="white" stopOpacity="0.08" />
        </radialGradient>
        <linearGradient
          id={paint3}
          x1="62"
          y1="12.8355"
          x2="62"
          y2="70.0234"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0.12" />
        </linearGradient>
        <linearGradient
          id={paint4}
          x1="57.7963"
          y1="25.0993"
          x2="57.7968"
          y2="39.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#58677E" />
          <stop offset="1" stopColor="#6B788D" />
        </linearGradient>
        <linearGradient
          id={paint5}
          x1="55.7789"
          y1="32.0701"
          x2="55.7795"
          y2="50.9396"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#606E84" />
          <stop offset="1" stopColor="#6B788D" />
        </linearGradient>
        <linearGradient
          id={paint6}
          x1="66.2811"
          y1="35.8083"
          x2="66.2816"
          y2="50.9472"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6A778C" />
          <stop offset="1" stopColor="#6B788D" />
        </linearGradient>
        <linearGradient
          id={paint7}
          x1="68.2789"
          y1="25.1091"
          x2="68.2795"
          y2="43.504"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#58677E" />
          <stop offset="1" stopColor="#6F7C91" />
        </linearGradient>
        <linearGradient
          id={paint8}
          x1="120"
          y1="1.02344"
          x2="120"
          y2="33.0234"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0.15" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.04" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect
            width="124"
            height="92"
            fill="white"
            transform="translate(0 13.0234)"
          />
        </clipPath>
        <clipPath id={clip1}>
          <rect
            width="30.0042"
            height="28.0007"
            fill="white"
            transform="translate(47 24.0234)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
